import * as React from 'react';
import './eventListPane.module.scss';
import { EventIndexView } from '../../../types/events';
import { EventCard } from '../../molecules/events/EventCard';
import { observer } from 'mobx-react';

type Props = {
  events: EventIndexView[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onItemClick: (event: EventIndexView) => any;
  archived?: boolean;
};

export const EventListPane = observer(
  class EventListPane extends React.Component<Props> {
    render() {
      const { events, onItemClick, archived = false } = this.props;
      return (
        <div styleName="new-pane">
          {events.map((event) => (
            <EventCard key={event.id} event={event} onClick={() => onItemClick(event)} archived={archived} />
          ))}
        </div>
      );
    }
  }
);
